import React, { FC } from 'react';
import { makeStyles } from '@mui/styles';
import cn from 'classnames';
import variables from 'styles/variables.scss';

type BoxPropsType = {
	width?: string;
	padding?: string;
	borderRadius?: string;
	border?: string;
	height?: string;
	minHeight?: string;
	margin?: string;
	bcColor?: string;
	boxShadow?: string;
	overflow?: string;
	className?: string;
	id?: string;
};

const BlockBox: FC<BoxPropsType> = ({
	bcColor,
	margin,
	width = '100%',
	padding = '0',
	border,
	borderRadius = '10px',
	height = '100%',
	minHeight,
	boxShadow,
	overflow,
	children,
	className,
	id,
}) => {
	const useStyles = makeStyles({
		boxWrapper: {
			backgroundColor: bcColor || '#FFFFFF',
			margin: margin || '0px',
			width,
			height,
			minHeight,
			padding,
			border,
			borderRadius,
			boxShadow,
			overflow,
			'&::-webkit-scrollbar': {
				height: '8px',
				backgroundColor: '#fff',
				width: '8px',
			},
			'&::-webkit-scrollbar-thumb': {
				backgroundСolor: variables.gray_5,
				background: variables.gray_5,
				borderRadius: '14px',
			},
		},
	});
	const classes = useStyles();
	return (
		<div className={cn(classes.boxWrapper, className)} id={id}>
			{children}
		</div>
	);
};

export default BlockBox;
